import React from 'react';
import css from './LoadingCircle.module.css';

const LoadingCircle = () => {
  return (
    <div className={css.loadingCircleContainer}>
      <svg className={css.loadingCircle} viewBox='0 0 48.91 48.5'>
        <path d='M24.46,48.5C10.97,48.5,0,37.53,0,24.05,0,12.5,8.2,2.42,19.5,.09c2.43-.5,4.81,1.06,5.32,3.5,.5,2.43-1.06,4.81-3.5,5.32-7.14,1.47-12.31,7.84-12.31,15.14,0,8.52,6.93,15.46,15.46,15.46s15.46-6.93,15.46-15.46c0-2.49,2.01-4.5,4.5-4.5s4.5,2.01,4.5,4.5c0,13.49-10.97,24.46-24.46,24.46Z' />
      </svg>
    </div>
  );
};

export default LoadingCircle;



